import { BarChart } from '@mui/x-charts';
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { serverAddress } from '../../config';
import { Global_Data } from '../../globalData/GlobalData';
import { addLabels, hasEmptyQueryValue, replacePlaceholders } from './CommonFunctions';
import { normalizeNumericStringsInRecords, replaceKeywordsInUrl } from './dashboard.utils';
import ComponentLoadingBoundary from '../Loading/ComponentLoadingBoundary';
import usePendingRequests from '../Loading/usePendingRequests';

const RenderBarchart = ({ data }) => {
    const [barchartDataResponse, setBarchartDataResponse] = useState();
    const { token, textValue } = Global_Data?.() || {};
    const { loading, trackRequest } = usePendingRequests();

    const dependencyFields = useMemo(() => {
        return data?.data?.sDataAware?.match(/{(.*?)}/g)?.map((field) => field.replace(/[{}]/g, "")) || [];
    }, [data?.data?.sDataAware]);

    const dependencies = useMemo(() => {
        return dependencyFields.map((field) => textValue?.[field] ?? null);
    }, [textValue, dependencyFields]);

    useEffect(() => {
        let finalURL = data?.data?.sDatasetSource;
        if(data?.data?.sDatasetSource?.includes(":[")){
            finalURL = replaceKeywordsInUrl(data?.data?.sDatasetSource);
        }
        if (!data?.data?.bCascade) {
            trackRequest(() => axios.get(`${serverAddress}${finalURL}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })).then(response => {
                const normalizedData = normalizeNumericStringsInRecords(response?.data?.data?.records);
                setBarchartDataResponse(normalizedData);
            }).catch(() => {
                // setGlobalError(error);
            });
        } else {
            let processedURL = replacePlaceholders(finalURL, textValue);
            const apiURI = `${serverAddress}${processedURL}`;
            const emptyParams = hasEmptyQueryValue(apiURI);
            if(emptyParams){
                trackRequest(() => axios.get(`${serverAddress}${processedURL}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })).then(response => {
                    setBarchartDataResponse(response);
                }).catch(() => {
                    // setGlobalError(error);
                });
            }
        }
    }, []);

    useEffect(() => {
        if (data?.data?.bCascade) {
            let processedURL = replacePlaceholders(data?.data?.sDatasetSource, textValue);
            if(processedURL?.includes(":[")){
                processedURL = replaceKeywordsInUrl(processedURL);
            }
            const apiURI = `${serverAddress}${processedURL}`;
            const emptyParams = hasEmptyQueryValue(apiURI);
            if(!emptyParams){
                trackRequest(() => axios.get(`${serverAddress}${processedURL}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })).then(response => {
                    const normalizedData = normalizeNumericStringsInRecords(response?.data?.data?.records);
                    setBarchartDataResponse(normalizedData);
                }).catch(() => {
                    // setGlobalError(error);
                });
            }
        }
    }, [data?.data?.sDatasetSource, dependencies]);

    return (
        <ComponentLoadingBoundary
            loading={loading}
            label={`Loading ${data?.component?.sName}`}
            minHeight={data?.component?.sProps?.height || 180}
            size={30}
        >
            {barchartDataResponse &&
                <BarChart
                    id={data?.component?.sName}
                    dataset={barchartDataResponse}
                    series={addLabels(data, data?.component?.sSeries, data?.component?.sFormatting)}
                    xAxis={[{ ...data?.component?.sXAxis }]}
                    yAxis={[{ ...data?.component?.sYAxis }]}
                    layout={data?.component?.sProps?.layout}
                    grid={data?.component?.sProps?.grid}
                    borderRadius={data?.component?.sProps?.borderRadius}
                    barLabel={(params) =>
                        params.value.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                    }
                    width={data?.component?.sProps?.width}
                    height={data?.component?.sProps?.height}
                    slotProps={data?.component?.sSlotProps}
                    margin={{ left: 70 }}
                />
            }
        </ComponentLoadingBoundary>
    )
}

export default RenderBarchart;
